import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const RegistrationHeader = () => {
  const navigate = useNavigate();

  return (
    <div className="text-center space-y-4">
      {/* Logo */}
      <div className="flex justify-center">
        <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center shadow-elevation-2">
          <Icon name="Heart" size={32} color="white" />
        </div>
      </div>

      {/* Welcome Text */}
      <div className="space-y-2">
        <h1 className="text-3xl font-bold text-foreground">
          Join Share Good
        </h1>
        <p className="text-lg text-muted-foreground max-w-md mx-auto">
          Start your charitable giving journey and connect with a community of changemakers
        </p>
      </div>

      {/* Benefits List */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-8 mb-8">
        <div className="flex flex-col items-center space-y-2 p-4">
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="Search" size={24} className="text-primary" />
          </div>
          <h3 className="font-semibold text-sm text-foreground">Discover Causes</h3>
          <p className="text-xs text-muted-foreground text-center">
            Find verified charities that match your values
          </p>
        </div>

        <div className="flex flex-col items-center space-y-2 p-4">
          <div className="w-12 h-12 bg-secondary/10 rounded-lg flex items-center justify-center">
            <Icon name="Users" size={24} className="text-secondary" />
          </div>
          <h3 className="font-semibold text-sm text-foreground">Join Community</h3>
          <p className="text-xs text-muted-foreground text-center">
            Connect with like-minded donors and share impact
          </p>
        </div>

        <div className="flex flex-col items-center space-y-2 p-4">
          <div className="w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center">
            <Icon name="BarChart3" size={24} className="text-accent" />
          </div>
          <h3 className="font-semibold text-sm text-foreground">Track Impact</h3>
          <p className="text-xs text-muted-foreground text-center">
            Monitor your giving and see real-world results
          </p>
        </div>
      </div>

      {/* Login Link */}
      <div className="flex items-center justify-center space-x-2 text-sm">
        <span className="text-muted-foreground">Already have an account?</span>
        <Button
          variant="link"
          onClick={() => navigate('/login')}
          className="p-0 h-auto font-semibold"
        >
          Sign in
        </Button>
      </div>
    </div>
  );
};

export default RegistrationHeader;